'use client'

import { ContextualMessage } from 'fukku/ContextualMessage'
import { CONTEXTUAL_MESSAGE_TYPE } from 'fukku/ContextualMessage/ContextualMessage'
import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { ORDER_TYPES } from 'my-purchases/constants/orderTypes'
import { usePurchaseDetails } from 'my-purchases/hooks/usePurchaseDetails/usePurchaseDetails'
import { usePurchaseStatusDetails } from 'my-purchases/hooks/usePurchaseStatusDetails/usePurchaseStatusDetails'
import { useSearchParams } from 'next/navigation'

import styles from './MultiOrderBanner.module.scss'

export function MultiOrderBanner({
	isOrderStatusPage,
}: {
	readonly isOrderStatusPage: boolean
}) {
	const { t } = useLabels()

	const searchParams = useSearchParams()
	const type = searchParams?.get('type') as ORDER_TYPES
	const purchaseId = searchParams?.get('purchaseId')
	const orderId = searchParams?.get('orderId')

	const { purchase } = usePurchaseDetails({
		type,
		purchaseId,
		orderId,
		disabled: isOrderStatusPage,
	})
	const { purchase: purchaseStatusDetails } = usePurchaseStatusDetails({
		purchaseId,
		disabled: !isOrderStatusPage,
	})

	const { orders, isMulti } = (purchase || purchaseStatusDetails) ?? {}

	if (!orders || !isMulti) {
		return null
	}

	return (
		<ContextualMessage
			className={styles.container}
			type={CONTEXTUAL_MESSAGE_TYPE.INFO}
			data-testid='myPurchases.online.multi.subtitle'
			message={
				<ClientLabel placeholderValues={{ 1: orders.length }}>
					{t('myPurchases.online.multi.subtitle')}
				</ClientLabel>
			}
		/>
	)
}
